import { mutations as accountMutations } from "./account/mutations.js";
import { mutations as customerMutations } from "./customer/mutations.js";
import { mutations as sellInquiryFormMutations } from "./sellInquiryForm/mutations.js";
import { mutations as contractMutations } from "./contract/mutations.js";
export default {
	...accountMutations,
	...customerMutations,
	...sellInquiryFormMutations,
	...contractMutations,
};
